<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useLogoStore } from '@/stores/logoStore'

export default defineComponent({
  name: 'LogoForApp',
  setup() {
    const router = useRoute()
    const logoStore = useLogoStore()

    const isNotNumberRegistrationAndInitialized = computed(() => {
      return (
        router.path !== '/number-registration'
        && router.path !== '/device-registration'
        && logoStore.isStatusViewInitialized
      )
    })

    const isNotBiometryPage = computed(() => {
      return (
        router.path !== '/beelive/scanner'
        && router.path !== '/beedoc/scanner'
        && router.path !== '/beelive/instruction'
        && router.path !== '/beedoc/instruction'
      )
    })

    return {
      isNotNumberRegistrationAndInitialized,
      isNotBiometryPage,
    }
  },
})
</script>

<template>
  <div v-if="isNotBiometryPage">
    <img
      class="logo"
      src="@/assets/icons/beeline-logo.svg"
      alt="bee-logo-big"
    >
    <img
      v-if="isNotNumberRegistrationAndInitialized"
      src="@/assets/icons/beeline-logo-small.svg"
      class="logo-small"
      alt="bee-logo-small"
    >
  </div>
</template>

<style scoped lang="scss">
.logo {
  width: 208px;
  height: 62px;
}
.logo-small {
  display: none;
}

@media screen and (max-width: 500px) {
  .logo {
    display: none;
  }

  .logo-small {
    width: 145px;
    height: 45px;
    display: block;
  }
}
</style>
